// Create the regex and handle the exceptions

export class RegexUtils {

    /**
     * @description Returns the regex if pattern is valid otherwise handle exception and return null.
     *
     * @param pattern {String}
     * @param modifiers {String}
     * @return {RegExp|null}
     */
    static safeRegEx (pattern, modifiers = '') {
        try {
            return new RegExp(pattern, modifiers);
        } catch (exception) {
            console.warn('Regex can not be created');
            return null;
        }
    }

    static getNameRegex () {

        let s = RegexUtils.getCharSets();
        let common = `^['_\\-\\s${s.numbers}${s.regular_1}${s.regular_2}${s.regular_3}${s.polish}${s.cyrillic}${s.hungarian}${s.japanese}${s.czech}]+$`;

        return new RegExp(common,'i');
    }

    static getUserNameRegex () {

        let s = RegexUtils.getCharSets();
        let common = `[${s.numbers}${s.regular_1}${s.regular_2}${s.regular_3}${s.polish}${s.cyrillic}${s.hungarian}${s.japanese}${s.czech}]`;
        let regex = `^${common}+(-${common}+)*( ${common}+(-${common}+)*)*$`;

        return new RegExp(regex,'i');
    }

    static getFarmNameRegex () {

        let s = RegexUtils.getCharSets();
        let common = `^['_\\-\\s${s.numbers}${s.regular_1}${s.regular_2}${s.regular_3}${s.polish}${s.cyrillic}${s.hungarian}${s.japanese}${s.czech}]+$`;

        return new RegExp(common,'i');
    }

    static getFieldNameRegex () {

        let s = RegexUtils.getCharSets();
        let common = `^[\\/'_().,+\\[\\]\\-\\s${s.numbers}${s.regular_1}${s.regular_2}${s.regular_3}${s.polish}${s.cyrillic}${s.hungarian}${s.japanese}${s.czech}]+$`;

        return new RegExp(common,'i');
    }

    static getCharSets () {

        let numbers = '\u0030-\u0039'; // - 0 to 9
        let regular_1 = '\u0041-\u005A'; // - A to Z, 
        let regular_2 = '\u00C0-\u00FF'; // - À to Ÿ and 
        let regular_3 = '\u0400-\u052F'; // - Ѐ to ԯ
        let polish = '\u0104-\u0107\u0118-\u0119\u0141-\u0144\u00D3\u00F3\u015A-\u015B\u0179-\u017C'; // polish special
        let cyrillic = '\u0400-\u04FF'; // - cyrillic basic
        let hungarian = '\u0150\u0151\u0170\u0171'; // - hungarian special
        let japanese = '\u3040-\u309f\u30a0-\u30ff\uff00-\uff9f\u4e00-\u9faf\u3400-\u4dbf'; // - japanese (https://stackoverflow.com/a/15034560)
        let czech = '\u010A-\u017E'; // - Czech special

        return { numbers, regular_1, regular_2, regular_3, polish, cyrillic, hungarian, japanese, czech};
    }
}


// WEBPACK FOOTER //
// ./shared/utils/RegexUtils.js